import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { OrderEditingService } from '@app/pages/order-editing/order-editing.service';
import { ShopService } from '@app/services/shops/shop.service';
import { CurrencySign } from '@pdqdev/pdq-shared/dist/entities';
import { OrderEditing } from '@pdqdev/pdq-shared/dist/interfaces';

@Component({
  selector: 'order-editing-form-shipping',
  standalone: false,
  templateUrl: './order-editing-form-shipping.component.html',
  styleUrl: './order-editing-form-shipping.component.scss',
})
export class OrderEditingFormShippingComponent implements OnInit {
  ShippingEligibleMethodsMode = OrderEditing.ShippingEligibleMethodsMode;
  methodNamesControl = new FormControl<string>('');
  private destroyRef = inject(DestroyRef);
  constructor(
    public orderEditingService: OrderEditingService,
    private shopService: ShopService,
  ) {}

  get currencySymbol(): CurrencySign {
    return this.shopService.shopCurrencySymbol || '$';
  }

  get formGroup() {
    return this.orderEditingService.form.get('template.settings.shippingRecalculation');
  }

  private get methodNamesFormControl() {
    return this.formGroup.get('methodNames');
  }

  private parseMethodNames(text: string): string[] {
    return text
      .split('\n')
      .map((name) => name.trim())
      .filter(Boolean);
  }

  ngOnInit(): void {
    this.methodNamesControl.setValue((this.methodNamesFormControl.value ?? []).join('\n'), { emitEvent: false });

    this.methodNamesControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((text) => {
      this.methodNamesFormControl.setValue(this.parseMethodNames(text ?? ''));
      this.methodNamesFormControl.markAsDirty();
    });

    this.methodNamesFormControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((names: string[]) => {
      const namesArr = names ?? [];
      const currentAsArray = this.parseMethodNames(this.methodNamesControl.value ?? '');
      if (JSON.stringify(currentAsArray) !== JSON.stringify(namesArr)) {
        this.methodNamesControl.setValue(namesArr.join('\n'), { emitEvent: false });
      }
    });
  }
}
